import React, { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

export const ATCIcon = ({ ...props }: Props) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 56.7 36.9"
      strokeWidth={0}
      stroke="currentColor"
      {...props}
   >
	<rect x="23.6" y="22.7" width="3.8" height="1.9"/>
	<path d="M55.9,19.9L49.5,19c-1.2-0.7-2.4-1.4-3.6-1.9c-0.4-0.2-0.7-0.3-1.1-0.5c-0.1-1.9-0.4-3.7-1.1-5.5c-0.5-1.4-1.4-2.8-2.9-3
		c-1.6-0.3-3.3-0.1-4.8-0.1l-1,0c-1.7,0-3,0.3-3.8,1.7c-0.9,1.5-1.1,3-0.8,4.4c-4.9,0.2-9.8,1.5-14.1,3.9L13,19.9
		c-3.8,0-7.5,1-10.8,2.9C0.8,23.6,0,25,0,26.5v5.6c0,0.5,0.4,1,1,1h3.2c1,2.9,4.2,4.5,7.2,3.5c1.6-0.6,2.9-1.8,3.5-3.5h17.9
		c0,0.4,0,0.9,0,1.3c0,1.3,0.8,2.2,1.9,2.2c1,0,1.9-1,1.9-2.2c0-0.5,0-0.9,0-1.3h0.7c0,0.5,0,1,0,1.6c0,1,0.9,1.9,1.9,1.9
		c0.9,0,1.7-0.7,1.9-1.6c1.5,1.6,3.9,2.3,6.1,1.6c1.6-0.6,2.9-1.8,3.5-3.5H51c0.1,0,0.2,0,0.3-0.1l3.1-1.2c1.4-0.5,2.3-1.9,2.3-3.3
		v-7.6C56.7,20.3,56.3,19.9,55.9,19.9z M32.1,19.7l0.5,0.2h-0.5C32.1,19.9,32.1,19.7,32.1,19.7z M41.2,17.3c0.3,0.1,0.6,0.2,0.9,0.3
		c0,0.7,0,1.5,0,2.2l-0.1,0.1h-0.9C41.2,19,41.2,18.2,41.2,17.3z M41.2,12.2c0.1,0,0.2,0,0.3,0C41.7,13.1,42,14,42,15
		c0,0.2,0,0.4,0,0.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.8,0-1.5,0-2.3C41.2,12.8,41.2,12.5,41.2,12.2z M32.7,12.6
		c0.1-0.9,0.5-1.6,1.2-1.9c-0.2,0.8-0.3,1.2-0.4,1.6l0,0l-0.6,1.5C32.7,13.4,32.7,13,32.7,12.6z M13.2,32c-0.4,2-2.4,3.4-4.5,3
		c-2-0.4-3.4-2.4-3-4.5c0.4-2.1,2.4-3.4,4.5-3c1.8,0.4,3,1.9,3,3.7C13.2,31.5,13.2,31.7,13.2,32z M30.2,31.2H15.1
		c0-3.1-2.5-5.7-5.7-5.7s-5.7,2.5-5.7,5.7H1.9v-4.7c0-0.9,0.5-1.7,1.2-2.1c3.1-1.8,6.6-2.7,10.1-2.7h17V31.2z M30.2,19.9H16.9
		l0.2-0.1c4-2.2,8.5-3.4,13.1-3.6V19.9z M32.1,31.2v-9.5h0.6v0.1c0,3.3,0,6.3,0,9.4H32.1z M36.6,31.2c0-3.1,0-6.2,0-9.3
		c0,0,0-0.1,0-0.1h0.7c0,2.7,0,5.3,0,8c0,0.5,0,1,0,1.5L36.6,31.2C36.6,31.2,36.6,31.2,36.6,31.2z M49.1,32c-0.4,2-2.4,3.4-4.5,3
		c-2-0.4-3.4-2.4-2.9-4.5c0.4-2.1,2.4-3.4,4.5-3c1.8,0.4,3,1.9,3,3.7C49.1,31.5,49.1,31.7,49.1,32z M54.8,22.7H52v1.9h2.8v3.9
		c0,0.7-0.4,1.3-1.1,1.6L51,31.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.1-0.3
		c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.2
		c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.2-0.2-0.2c0-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2C49.1,27,49,26.9,49,26.8s-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.2
		s-0.2-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1
		c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0
		c-1.6,0-3.1,0.7-4.1,1.8c0-1.9,0-3.7,0-5.6h1c0.1,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.3-1.3c0-0.5,0.1-1.1,0.1-1.6
		c0,0,0-0.1,0-0.1l0.8-0.8c1,0.5,2,1,3,1.6c0.1,0.1,0.2,0.1,0.4,0.1l5.8,0.8V22.7z"  fill="currentColor"/>
	<path d="M36.9,7c1.9,0.1,3.5-1.5,3.6-3.4C40.5,1.6,39,0,37,0c-2,0-3.6,1.5-3.6,3.5C33.4,5.4,34.9,7,36.9,7z"  fill="currentColor"/>
   </svg>
);